<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>业务参数</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="no-data" v-if="bizParamGroupList == null || bizParamGroupList.length <= 0">
            <span>暂无业务参数</span>
        </div>
        <div v-else>
            <div v-for="bizParamGroup in bizParamGroupList">
                <div class="content-caption dashed bg-white">
                    <span>{{bizParamGroup.name}}</span>
                </div>
                <div v-if="bizParamGroup.comBizParamList == null || bizParamGroup.comBizParamList.length <= 0">
                    <span>暂无业务参数</span>
                </div>
                <div class="setting-info" v-else>
                    <div class="setting-row" v-for="bizParam in bizParamGroup.comBizParamList">
                        <div class="setting-value">
                            <swb-pattern-input class="inline-block" :viewMode="true" :pattern="bizParam.pattern" :initValue="bizParam.value" :inputType="bizParam.inputType" :valueType="bizParam.typeName" :ref="bizParam.code"></swb-pattern-input>
                            <span class="inline-block ml10">描述：{{bizParam.desc || '无'}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import merchtComnApi from '../../api/merchtComn'

    import SwbPatternInput from '../ctrl/PatternInput';
    Vue.regist(SwbPatternInput);

    export default {
        name: 'swb-com-biz-param-list',
        desc: '公司业务参数列表',
        props: ['realComId'],
        data: function () {
            return {
                bizParamGroupList: [],
                finacFlag: false,
            }
        },
        created: function () {
            //
            this.getBizParamGroupListByFilter();
        },
        methods: {
            getBizParamGroupListByFilter: function () {
                let self = this;
                let postData = {
                    realComId: self.realComId,
                    codeList: null
                };
                merchtComnApi.getComBizParamGroupList(postData, function (result) {
                    if(result.type == "info") {
                        let bizParamGroupList = result.data;
                        if(bizParamGroupList.length > 0) {
                            for(let i = 0; i < bizParamGroupList.length; i++) {
                                let bizParamGroup = bizParamGroupList[i];
                                if(bizParamGroup.code == 'asset.biz.setting') {
                                    let comBizParamList = bizParamGroup.comBizParamList || [];
                                    if(comBizParamList.length > 0) {
                                        for(let j = 0; j < comBizParamList.length; j++) {
                                            let bizParam = comBizParamList[j];
                                            if(bizParam.code == 'asset.finac.enabled') {
                                                self.finacFlag = Utils.isTrue(bizParam.value);
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        self.bizParamGroupList = Utils.merge([], bizParamGroupList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                let bizParamGroup = self.bizParamGroupList;
                let sumitBizParamList = [];
                let finacEnabled = false;
                for(let i = 0; i < bizParamGroup.length; i++) {
                    let comBizParamList = bizParamGroup[i].comBizParamList;
                    for(let j = 0; j < comBizParamList.length; j++) {
                        let bizParam = comBizParamList[j];
                        if(bizParam.code != "asset.finac.enabled") {
                            bizParam.value = self.$refs[bizParam.code][0].getValue();
                        } else {
                            finacEnabled = Utils.isTrue(bizParam.value);
                        }
                        //
                        sumitBizParamList.push(bizParam);
                    }
                }
                if(!Utils.isNoB(sumitBizParamList) && sumitBizParamList.length > 0) {
                    if(!self.finacFlag && finacEnabled) {
                        result.message = '仅使用在账资产定义后只能使用标准化的定义，确定是否继续？';
                    }
                    result.data = {
                        realComId: self.realComId,
                        comBizParamList: sumitBizParamList
                    };
                    result.type = 'info';
                } else {
                    result.type = 'wran';
                    result.message = "没有需要设置的参数";
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizParam/ComBizParamList.vue